import { useCurrentFile } from 'shared/Providers/CurrentFile';
import { FieldTextField } from 'shared/_ui/form/form-text-field';
import { prettySize, prettyTime } from 'shared/utils/format';
import { CardHeader, Card, CardContent, SxProps, Theme } from '@mui/material';

function isMedia(metaType: string) {
	return ['video', 'audio'].includes(metaType);
}

export default function FileDetails({ sx }: { sx?: SxProps<Theme> }) {
	const { file } = useCurrentFile();

	return (
		<Card sx={sx}>
			<CardHeader title="Video Details" />
			<CardContent>
				{isMedia(file.meta?.type) && (
					<FieldTextField
						key="file.meta.duration"
						label="Duration:"
						value={prettyTime(file.meta.duration)}
						fullWidth
						labelProps={{ width: '4.75rem' }}
					/>
				)}
				{file.size && (
					<FieldTextField
						key="file.size"
						label="Size:"
						value={prettySize(file.size)}
						fullWidth
						labelProps={{ width: '4.75rem' }}
					/>
				)}
			</CardContent>
		</Card>
	);
}
